
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/azienda/[slug]",
      function () {
        return require("private-next-pages/azienda/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/azienda/[slug]"])
      });
    }
  